module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/chevron-down-ee533a74ba3dd4b46a418303b090588e.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/chevron-down.svg
// module id = lYHl
// module chunks = 24